import _get from "lodash/get";
import React from "react";
import PropTypes from "prop-types";
import { Grid, Loader } from "semantic-ui-react";
import {
  DeleteButton,
  EditButton,
  ExternalWorkflowButton,
  PublishButton,
  PublishRequestButtonMenu,
  CancelExternalWorkflowButton,
  CopyButton,
} from "../buttons";
import {
  ActionMenuTooltip,
  EditButtonTooltips,
  PublishButtonTooltips,
  RunQCButtonTooltips,
} from "../utils";
import { getPublishRequest, getWorkflowRequest } from "./tools";

export const ActionMenu = ({ draftId, draftRequests, isLoading, draft }) => {
  const activePublishedRequest = getPublishRequest(draftRequests);
  const datasetTypeCode = _get(
    draft,
    "metadata.datasetType.datasetTypeCode",
    "",
  );
  const title = _get(draft, "metadata.titles[0].titleText", "Untitled Draft");
  const state = draft.state;
  if (isLoading) {
    return <Loader />;
  }
  return (
    <Grid>
      <Grid.Row columns={2} style={{ padding: "0" }}>
        <Grid.Column>
          <DeleteButton draftId={draftId} state={state} />
        </Grid.Column>
        <Grid.Column>
          <ActionMenuTooltip
            state={state}
            tooltips={EditButtonTooltips}
            trigger={
              <EditButton
                draftId={draftId}
                disabled={["running", "submitted"].includes(state)}
              />
            }
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2} style={{ padding: "0.5rem 0 1rem 0" }}>
        <Grid.Column>
          {state === "running" ? (
            <CancelExternalWorkflowButton
              request={getWorkflowRequest(draftRequests)}
            />
          ) : (
            <ActionMenuTooltip
              state={state}
              tooltips={RunQCButtonTooltips}
              trigger={
                <ExternalWorkflowButton
                  draftId={draftId}
                  disabled={["running", "submitted"].includes(state)}
                />
              }
            />
          )}
        </Grid.Column>
        <Grid.Column>
          <CopyButton draft={draft} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          {state !== "submitted" ? (
            <ActionMenuTooltip
              state={state}
              tooltips={PublishButtonTooltips}
              trigger={
                <PublishButton
                  draftId={draftId}
                  draftTitle={title}
                  datasetTypeCode={datasetTypeCode}
                  disabled={state !== "validated"}
                />
              }
            />
          ) : isLoading || !activePublishedRequest ? (
            <Loader />
          ) : (
            <PublishRequestButtonMenu
              request={activePublishedRequest}
            ></PublishRequestButtonMenu>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

ActionMenu.propTypes = {
  draftId: PropTypes.string.isRequired,
  draft: PropTypes.object.isRequired,
  draftRequests: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
